<mat-button-toggle-group class="lang-menu" vertical (change)="onLanguageSelected($event)" [value]="getCurrentLanguage()">
    @for(lang of languages; track lang){
        <mat-button-toggle class="no-borders" [value]="lang">{{'GENERAL.LANGUAGES.' + lang | translate}}</mat-button-toggle>
    }
</mat-button-toggle-group>
